import Model from 'src/app/common/model';
import BusinessItemsModel from './businessItems.model';
import UOMConversionModel from './uomConversion.model';
import FarmSiteModel from './farmSite.model';
import BusinessEntity from './businessEntity.model';
import ItemMasterModel from './itemMaster.model';
import UOMMasterModel from './uom.model';
import TransactionTypeModel from './transactionType.model';
import ItemTypesModel from './itemTypes.model';
import TransactionsModel from './transactions.model';

export default class OnHandQuantitiesModel extends Model {
  BusinessItem: BusinessItemsModel;
  UOMConversion: UOMConversionModel;
  ItemMaster: ItemMasterModel;
  farmSiteDetails: FarmSiteModel; // TC
  BusinessDetails: BusinessEntity; // TC
  ReorderUOM: UOMMasterModel;
  UOMMaster: UOMMasterModel;
  TransactionType: TransactionTypeModel;
  ItemType: ItemTypesModel;
  Transaction: TransactionsModel;
  business_id?: string;
  farm_site_id?: string;
  item_id?: number;
  as_of_date?: string;
  transaction_id: number;
  opening_stock?: number;
  onHand?: number;
  value?: number;
  uom_id?: number;
  issues?: number;
  filePath: string;
  balance_migration?: number;
  purchase?: number;
  transfer?: number;
  miscellaneous?: number;
  reversal?: number;
  reversal_value?: number;
  production_unit_id?: string;
  isBH: number;
  from_date: string;
  to_date: string;
  fromDate: string;
  toDate: string;
  businessId: string;
  farmSiteId: string;
  transaction_date: string;
  item_name: string;
  sub_type: string;
  name: string;
  balanceMigration: number;
  businessName: string;
  farmNameAtLocation: string;

  constructor() {
    super();
  }
}
